import Highcharts from "highcharts/highcharts";
import _ from "lodash/lodash";
import ViewController from "core/views/view.controller";
import {Colors} from "main/main.config";

function dataLabelsFormatter() {
    return this.y > 0 ? this.y : '';
}

export default class ChartResourceWorkloadCtrl extends ViewController {
    static $inject = ['$scope'];

    constructor() {
        super(...arguments);
        this.chart = null;

        // Bindings
        this.workloads = [];
    }

    $onInit() {
        if (!this.chart) {
            this.createChart();
        }
    }

    $onChanges(changes) {
        if (!changes.workloads) {
            return;
        }

        if (!changes.workloads.currentValue || !changes.workloads.currentValue.length) {
            this.workloads = [];
        }

        if (!this.chart) {
            this.createChart();
        }

        this.updateChart();
    }

    updateChart() {
        let seriesData = [];
        let categories = [];

        _(this.workloads)
            .sortBy(workload => workload.resource.name.toLowerCase())
            .each((workload => {
                categories.push(workload.resource.name);
                seriesData.push(workload.percentage);
            }));

        this.chart.xAxis[0].setCategories(categories);
        this.chart.series[0].setData(seriesData);
        this.chart.setSize(null, null, false);
    }

    createChart() {
        this.chart = Highcharts.chart('chart-resource-workload-hs', {
            chart: {
                type: 'column',
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false,
                spacingBottom: 10,
                spacingTop: 10,
                spacingLeft: 0,
                spacingRight: 0,
            },

            title: {
                text: ''
            },

            tooltip: {
                enabled: false
            },

            xAxis: {
                type: 'category',
                categories: [],
                labels: {
                    rotation: -45,
                    style: {
                        color: Colors.textNormal,
                        fontSize: '14px',
                        fontWeight: '400',
                        fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif'
                    }
                }
            },

            yAxis: {
                allowDecimals: false,
                min: 0,
                max: 100,
                minRange: 100,
                title: {
                    text: ''
                }
            },

            plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}%',
                        style: {
                            color: Colors.textNormal,
                            fontSize: '14px',
                            fontWeight: '600',
                            fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif'
                        }
                    }
                },

                series: {
                    enableMouseTracking: false
                }
            },

            legend: {
                enabled: true,
                itemStyle: {
                    color: Colors.textNormal,
                    fontSize: "14px",
                    fontWeight: '400',
                    fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif'
                }
            },

            series: [{
                name: 'Auslastung in %',
                data: [0],
                color: Colors.highlight1
            }]
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-resource-workload/chart-resource-workload.controller.js